import React from "react";
import "../styles/app.css";
import { FaArrowLeft, FaCalendarAlt } from 'react-icons/fa';
import { MdOutlineTouchApp } from "react-icons/md";

function formatDateIST(isoString) {
  const date = new Date(isoString);
  return date.toLocaleDateString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "Asia/Kolkata"
  });
}

export default function OfferDetails({ offer, goBack }) {
  return (
    <div className="offer-details">
      <button className="go-back-button" onClick={goBack}><FaArrowLeft size={13} color="black" /> Go Back</button>

      <img src={offer.image.url} alt="offer full" className="offer-detail-img" />
      <h2>{offer.title}</h2>

      <div className="details-meta">
        <span>Posted: <FaCalendarAlt /> {formatDateIST(offer.post_date)}</span>
        <span>Ends: <FaCalendarAlt /> {formatDateIST(offer.end_date)}</span>
      </div>

      <div className={`bubble big ${offer.offer_type.toLowerCase()}`}>
        {offer.offer_type}
      </div>

      <p>
        {offer.description.split(/\r?\n/).map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </p>
      {offer.is_package_linked && (
        <button className="package-navigate" onClick={() => {
          if (window.RoyalSkyWebViewPackageNavigate && window.RoyalSkyWebViewPackageNavigate.postMessage) {
            window.RoyalSkyWebViewPackageNavigate.postMessage(offer.package_id);
          } else {
            console.log(offer.package_id);
          }
        }}>
          <MdOutlineTouchApp size={13} color="white" /> Book Now
        </button>
      )}
      <button className="go-back-button-full-width" onClick={goBack}><FaArrowLeft size={13} color="white" /> Go Back</button>
    </div>
  );
}